import { ShippingsActionTypes } from "./constants";

const INIT_STATE = {
  list: [],
  total: 0,
  one: null,
  loading: false,
};

interface ShippingCreate {
  country: string;
  comment: string;
  description: string;
  orderDate: Date;
  from: any;
  mode: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
  transporterName: string;
  transporterPhone: string;
  weight: number;
}

interface ShippingsData {
  items?: any[];
  total?: number;
}

interface GetShippingsData {
  id: string;
}

interface ShippingsActionType {
  type:
    | ShippingsActionTypes.GET_LIST_SHIPPINGS
    | ShippingsActionTypes.GET_LIST_SHIPPINGS_ERROR
    | ShippingsActionTypes.GET_LIST_SHIPPINGS_SUCCESS
    | ShippingsActionTypes.GET_SHIPPING
    | ShippingsActionTypes.GET_SHIPPING_SUCCESS
    | ShippingsActionTypes.GET_SHIPPING_ERROR
    | ShippingsActionTypes.UPDATE_SHIPPING
    | ShippingsActionTypes.UPDATE_SHIPPING_SUCCESS
    | ShippingsActionTypes.UPDATE_SHIPPING_ERROR
    | ShippingsActionTypes.UPDATE_STATUS_SHIPPING
    | ShippingsActionTypes.UPDATE_STATUS_SHIPPING_SUCCESS
    | ShippingsActionTypes.UPDATE_STATUS_SHIPPING_ERROR
    | ShippingsActionTypes.UPDATE_DELIVERY_SHIPPING
    | ShippingsActionTypes.UPDATE_DELIVERY_SHIPPING_SUCCESS
    | ShippingsActionTypes.UPDATE_DELIVERY_SHIPPING_ERROR
    | ShippingsActionTypes.DELETE_SHIPPING
    | ShippingsActionTypes.DELETE_SHIPPING_SUCCESS
    | ShippingsActionTypes.DELETE_SHIPPING_ERROR
    | ShippingsActionTypes.DOWNLOAD_SHIPPINGS_LIST
    | ShippingsActionTypes.DOWNLOAD_SHIPPINGS_LIST_SUCCESS
    | ShippingsActionTypes.DOWNLOAD_SHIPPINGS_LIST_ERROR;
  payload: {
    actionType?: string;
    data?: ShippingsData;
    createData?: ShippingCreate;
    getShipping?: GetShippingsData;
    error?: string;
    updated: false;
    refreshList: false;
  };
}

interface State {
  list?: any[];
  total?: number;
  one?: any;
  loading?: boolean;
  value?: boolean;
}

const Shippings = (
  state: State = INIT_STATE,
  action: ShippingsActionType
): any => {
  switch (action.type) {
    case ShippingsActionTypes.GET_SHIPPING:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        total: 0,
        updated: false,
      };
    case ShippingsActionTypes.GET_SHIPPING_SUCCESS:
      switch (action.payload.actionType) {
        case ShippingsActionTypes.GET_SHIPPING: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            updated: false,
          };
        }
        default:
          return { ...state };
      }

    case ShippingsActionTypes.GET_SHIPPING_ERROR:
      switch (action.payload.actionType) {
        case ShippingsActionTypes.GET_SHIPPING: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            updated: false,
          };
        }
        default:
          return { ...state };
      }

    case ShippingsActionTypes.UPDATE_SHIPPING:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",

        total: 0,
      };
    case ShippingsActionTypes.UPDATE_SHIPPING_SUCCESS:
      switch (action.payload.actionType) {
        case ShippingsActionTypes.UPDATE_SHIPPING: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            updated: true,
          };
        }
        default:
          return { ...state };
      }

    case ShippingsActionTypes.UPDATE_SHIPPING_ERROR:
      switch (action.payload.actionType) {
        case ShippingsActionTypes.UPDATE_SHIPPING: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case ShippingsActionTypes.UPDATE_STATUS_SHIPPING:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        total: 0,
        refreshList: false,
      };
    case ShippingsActionTypes.UPDATE_STATUS_SHIPPING_SUCCESS:
      switch (action.payload.actionType) {
        case ShippingsActionTypes.UPDATE_STATUS_SHIPPING: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            updated: true,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case ShippingsActionTypes.UPDATE_STATUS_SHIPPING_ERROR:
      switch (action.payload.actionType) {
        case ShippingsActionTypes.UPDATE_STATUS_SHIPPING: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case ShippingsActionTypes.UPDATE_DELIVERY_SHIPPING:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        total: 0,
        refreshList: false,
      };
    case ShippingsActionTypes.UPDATE_DELIVERY_SHIPPING_SUCCESS:
      switch (action.payload.actionType) {
        case ShippingsActionTypes.UPDATE_DELIVERY_SHIPPING: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            updated: true,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case ShippingsActionTypes.UPDATE_DELIVERY_SHIPPING_ERROR:
      switch (action.payload.actionType) {
        case ShippingsActionTypes.UPDATE_DELIVERY_SHIPPING: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case ShippingsActionTypes.GET_LIST_SHIPPINGS_SUCCESS:
      switch (action.payload.actionType) {
        case ShippingsActionTypes.GET_LIST_SHIPPINGS: {
          return {
            ...state,
            list: action.payload.data.items,
            loading: false,
            total: action.payload.data.total,
            one: null,
            error: "",
            updated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case ShippingsActionTypes.GET_LIST_SHIPPINGS_ERROR:
      switch (action.payload.actionType) {
        case ShippingsActionTypes.GET_LIST_SHIPPINGS: {
          // Voir Orders : on garde list/total pour ne pas vider l'écran sur
          // un 401 pendant refresh token / blip réseau.
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            updated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case ShippingsActionTypes.GET_LIST_SHIPPINGS:
      return {
        ...state,
        loading: true,
        one: null,
        error: "",
        updated: false,
        refreshList: false,
      };
    case ShippingsActionTypes.DELETE_SHIPPING:
      return {
        ...state,
        refreshList: false,
      };
    case ShippingsActionTypes.DELETE_SHIPPING_SUCCESS:
      switch (action.payload.actionType) {
        case ShippingsActionTypes.DELETE_SHIPPING: {
          return {
            ...state,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case ShippingsActionTypes.DOWNLOAD_SHIPPINGS_LIST:
      return {
        ...state,
        loading: true,
      };

    case ShippingsActionTypes.DOWNLOAD_SHIPPINGS_LIST_SUCCESS:
      switch (action.payload.actionType) {
        case ShippingsActionTypes.DOWNLOAD_SHIPPINGS_LIST: {
          return {
            ...state,
            loading: false,
            error: "",
          };
        }
        default:
          return { ...state };
      }

    case ShippingsActionTypes.DOWNLOAD_SHIPPINGS_LIST_ERROR:
      switch (action.payload.actionType) {
        case ShippingsActionTypes.DOWNLOAD_SHIPPINGS_LIST: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case ShippingsActionTypes.DELETE_SHIPPING_ERROR:
      switch (action.payload.actionType) {
        case ShippingsActionTypes.DELETE_SHIPPING: {
          return {
            ...state,
            error: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }
    default:
      return { ...state };
  }
};

export default Shippings;
